<template>
    <div>
      <el-row style="height: 40px">
        <span style="font-size: 12px">商品修改时间</span>

        <el-date-picker
          style="" size="small"
          :default-time="['00:00:00', '23:59:59']"
          v-model="tradeDate"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"  format="MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right">
        </el-date-picker>

        <el-button type="primary" size="small" @click="startItem">同步商品信息</el-button>
        <el-button type="primary" size="small" @click="gotoSku" style="margin-right: 20px; margin-left: 20px">SKU信息</el-button>
        <el-input v-model="title" size="small" style="width: 200px"></el-input>
        <el-button type="primary" size="small"  @click="getItemData" >搜索</el-button>

        <el-button type="primary" size="small"  @click="openUpdateTitle" >修改标题</el-button>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table border  style="font-size: 12px" :data="itemData" ref ="multipleTable"  :cell-style="{padding: '0px'}"
                    :header-cell-style="{background:'#F2F6FC',color:'#000'}">
            <el-table-column label="主图" width="80px">
              <template slot-scope="scope" >
                <img width="60px" height="60px" :src="scope.row.picUrl+'_60x60.jpg'" />
              </template>
            </el-table-column>
            <el-table-column  label="商品名称" >
              <template slot-scope="scope">
                {{scope.row.title}}<a :href="'https://detail.tmall.com/item.htm?id='+scope.row.numIid"
                                          target="_blank"
                                          class="primary">&#8194;详情</a>
              </template>
            </el-table-column>

            <el-table-column  prop="hh" label="货号" width="120px"></el-table-column>
            <el-table-column  prop="price" label="单价" width="80px"></el-table-column>
            <el-table-column  prop="itemWeight" label="重量" width="80px"></el-table-column>
            <el-table-column  prop="itemSz" label="体积" width="80px"></el-table-column>
            <el-table-column  label="简称" >
              <template slot-scope="scope">
                <el-input type="textarea" :rows="2"  v-model="scope.row.shortName"></el-input>
              </template>
            </el-table-column>
            <el-table-column  label="成本" width="120px">
              <template slot-scope="scope">
                <el-input type="textarea" :rows="1"  v-model="scope.row.cost"></el-input>
              </template>
            </el-table-column>
            <el-table-column  label="" width="80px">
              <template slot-scope="scope">
                <el-button type="primary" size="mini"  style="display: inline" @click="updateMemo(scope.$index, scope.row)">更新</el-button>
              </template>
            </el-table-column>
            <el-table-column            type="selection"            width="45">          </el-table-column>

            </el-table>
        </el-col>
      </el-row>

      <div class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObject.pageCurrent"
          :page-sizes="[20, 50, 100, 500, 1000, 2000]"
          :page-size="pageObject.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObject.rowCount">
        </el-pagination>
      </div>

      <el-dialog :close-on-click-modal="false"
                 title="修改标题"
                 :visible.sync="showTitle"
                 width="550px"
                 center>

        <div style="margin-bottom: 30px"><span>原关键字：</span><el-input v-model="oldStr" size="small" style="width: 400px" placeholder=""></el-input>
        </div>
        <div><span>新关键字：</span><el-input v-model="newStr" size="small" style="width: 400px"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button  @click="showTitle=false">取 消</el-button>
        <el-button type="primary" @click="batUpdateTitle">确 定</el-button>
      </span>
      </el-dialog>
    </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"
  import datefmt from "../api/date"

    export default {
        name: "Item",
      data(){
          return{
            title:'',
            deny:0,
            itemData:[],
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 20
            },
            showTitle:false,
            oldStr:'',
            newStr:'',
            timer:null,
            funName:'',
            cnName:'',
            //同步完成后提示
            msg:"",
            tradeDate:[],
            pickerOptions: {
              shortcuts: [{
                text: '今天',
                onClick(picker) {
                  const end = new Date();

                  let year2, month2, day2
                  [year2, month2, day2] = [end.getFullYear(), end.getMonth(), end.getDate()]
                  let start = new Date(year2, month2, day2, 0)
                  picker.$emit('pick', [start, end]);
                }
              },{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
          }
      },
      methods:{
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getItemData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getItemData();
        },
        getItemData:function () {
          let param={
            nick: storage.get("nick"),
            title:this.title,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/item/getItem", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.itemData = dataResult.data.item;

              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;

            }else{
              this.deny = 1;
              this.$message.error(dataResult);
              this.$router.replace({name: "Index"});
            }

          })
        },
        openUpdateTitle(){
          // const  selectData = this.$refs.multipleTable.selection;
          // if(selectData.length == 1){
          //   this.oldStr = selectData[0].title;
          // }
          this.showTitle = true;
        },
        batUpdateTitle(){
          const  selectData = this.$refs.multipleTable.selection;
          if(selectData.length ==0){
            this.$message.error("请先选择要修改的商品")
            return
          }

          if((this.oldStr.length == 0) ||(this.newStr.length == 0)){
            this.$message.error("原关键字和新关键字都不能为空")
            return
          }
          let numIids = "";
          for(let i=0;i<selectData.length;i++){
            numIids += selectData[i].numIid+","
          }
          numIids = numIids.slice(0, numIids.length-1);
          console.log("numIids:" +  numIids);
          let param={
            nick:storage.get('nick'),
            numIids: numIids,
            oldStr: this.oldStr,
            newStr: this.newStr
          }
          $api.post("/item/updateTitle", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              let msg = dataResult.data;
              if(msg.length == 0){
                this.$message.success("修改成功")
              }else{
                this.$message.warning(msg);
              }
              this.showTitle=false;
              this.getItemData();
            }
          })
        },

        //轮询同步状态
        getStatus:function () {
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subNick:storage.get("subnick"),
            funName:this.funName,
            status:"1",
          }
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            if(dataResult.data == "success") {
              this.getItemData();
              clearTimeout(this.timer);
              this.$message.success("【"+this.cnName +"】数据同步完成。");
              this.msg="【"+this.cnName +"】数据同步完成。";
            }
            else {
              this.timer = setTimeout(this.getStatus, 3000);
              this.msg='running';
              this.$message.warning("【"+this.cnName +"】数据同步中.....");
            }

          })
        },

        startItem:function() {
          if(this.deny == 1){
            console.log(this.deny);
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          this.$confirm('即将开始从淘宝获取数据，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            this.getTbItem();
          })
        },

        getTbItem :function(){
          this.funName="GetItems";
          this.cnName=" 商品 ";
          let param ={
            nick: storage.get("nick"),
            subNick:storage.get("subnick"),
            startDate: this.tradeDate[0],
            endDate: this.tradeDate[1],
            allItem:'',
          }
          $api.post("/item/getTbItem", param , response =>{
            let dataResult =  response.data;
            if(dataResult.state == 1 && dataResult.message == 'ok'){

              this.timer = setTimeout(this.getStatus, 1000);

            }else{
              this.$message.error(dataResult);
            }
          })
        },
        gotoSku:function(){
          if(this.deny == 1){
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          this.$router.replace({name: 'Sku'});
        },
        updateMemo:function (index, row) {
          let param ={
            nick:storage.get("nick"),
            numIid: row.numIid,
            shortName: row.shortName,
            cost:row.cost,
          };
          $api.post("/item/updateItemShortName", param, response => {
            let dataResult = response.data;

            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.$message({
                type: 'success',
                message: '恭喜，设置简称成本价成功！'
              });
            }else {
              this.$message.error(dataResult);
            }
          })
        },
      },
      mounted(){
        this.getItemData();
        //当前设定的日期时间
        let d = new Date
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()]
        let date1 = new Date(year1, month1, day1, 23, 59, 59)
        //this.tradeDate.push(date1)

        //前一天设定的日期时间
        let year2, month2, day2
        //d.setTime(d.getTime() - 7 * 24 * 60 * 60 * 1000);
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()]
        let date2 = new Date(year2, month2, day2, 0)
        //this.tradeDate.unshift(date2)
        this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date2))
        this.tradeDate.push(datefmt.dateFormat("yyyy-MM-dd HH:mm:ss", date1))
      }
    }
</script>

<style >
  a{
    color: #409EFF;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/page/Item.vue